import { render, staticRenderFns } from "./MainDashboards.vue?vue&type=template&id=abc83cd4&scoped=true"
import script from "./MainDashboards.vue?vue&type=script&lang=ts"
export * from "./MainDashboards.vue?vue&type=script&lang=ts"
import style0 from "./MainDashboards.vue?vue&type=style&index=0&id=abc83cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc83cd4",
  null
  
)

export default component.exports